import * as React from "react";
import ActionCard from './ActionCard';
import { EntityType } from "../../../entities/common";
import PortfolioCreation from "../../portfolio/PortfolioCreation";
import ProgramCreation from "../../program/ProgramCreation";
import ProjectCreation from "../../project/ProjectCreation";
import ChallengeCreation from "../../challenge/ChallengeCreation";

type Props = {
    name: string;
    iconName: string;
    disabled: boolean;
    entityType: EntityType;
}

const CreateEntityActionCard = (props: Props) => {
    const [currentEntityType, setCurrentEntityType] = React.useState<EntityType>();
    const onDismiss = React.useCallback(() => setCurrentEntityType(undefined), []);
    return <>
        <ActionCard
            iconName={props.iconName}
            name={props.name}
            disabled={props.disabled}
            action={() => setCurrentEntityType(props.entityType)}
        />
        {currentEntityType === EntityType.Challenge && <ChallengeCreation key="challenge-creation" onDismiss={onDismiss} openOnComplete />}
        {currentEntityType === EntityType.Portfolio && <PortfolioCreation key="portfolio-creation" onDismiss={onDismiss} openOnComplete />}
        {currentEntityType === EntityType.Program && <ProgramCreation key="program-creation" onDismiss={onDismiss} openOnComplete />}
        {currentEntityType === EntityType.Project && <ProjectCreation key="project-creation" onDismiss={onDismiss} openOnComplete />}
    </>;
}

export default CreateEntityActionCard;
